export default "__VITE_ASSET__BkLF63cu__";